export default function DevExtension() {
  if (window.parent) {
    window.parent.postMessage({
      type: 'SEEDBOT_DEV_EXTENSION_AUTH',
      token: localStorage.getItem('token'),
      flowId: localStorage.getItem('flow_id'),
    }, '*');
  }
}